import { Component, OnInit, SimpleChanges, Input, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { saveAs } from "file-saver";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-evidence-reference-pt',
  templateUrl: './evidence-reference-pt.component.html',
  styleUrls: ['./evidence-reference-pt.component.scss']
})
export class EvidenceReferencePtComponent implements OnInit {

  // evidenceList = []
  evidenceFormEdit
  eviReferencePTForm
  learnerId
  currentLearner
  jobId
  loading
  job
  @Input('list') evidenceList
  @Input('learner') learnerData;
  @Input('job') singleJob;
  @Input('assessment') evidencerefercnceEdit;
  user: any;
  isLearner: boolean = false;
  isDisplay: boolean = false
  private evidenceSubscription: Subject<any> = new Subject<any>();
  private deleteEvidenceSubscription: Subject<any> = new Subject<any>();
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public cd: ChangeDetectorRef
  ) {

    this._learnerService.newEvidenceObservable().subscribe((newEvidence) => {
      console.log("new Evidence Here ====>", newEvidence)
      // let data1 = {
      //   _id: newEvidence.data._id,
      //   title: newEvidence.data.title,
      //   evidenceNo: newEvidence.data.evidenceNo,
      //   feedback: newEvidence.data.feedback

      // }
      let data1 = newEvidence.data
      this.evidenceList.push(data1)
    })

    this._learnerService.removeEvidenceObservable()
      .pipe(
        takeUntil(this.deleteEvidenceSubscription)
      )
      .subscribe((removeEvidence) => {
        console.log("new remove Evidence ====>", removeEvidence)


        let index = this.evidenceList.findIndex(x => x._id === removeEvidence._id);
        if (index > -1) {
          this.evidenceList.splice(index, 1)
          console.log("after learner remove in assignment page", this.evidenceList);
        }
        if (this.evidenceFormEdit) {
          this.isDisplay = true
          this.createForm(this.evidenceFormEdit)
          this.submitEvirefernce()
        }
      })


    this._learnerService.editEvidenceObservable()
      .pipe(
        takeUntil(this.evidenceSubscription)
      )
      .subscribe((editEvidence) => {
        console.log("Here is Edit Evidence Observable===>", editEvidence)
        let data1 = editEvidence[0]
        let index = this.evidenceList.findIndex(x => x._id === editEvidence[0]._id);
        if (index > -1) {
          this.evidenceList.splice(index, 1, data1)
          console.log("after learner remove in assignment page", this.evidenceList);
        }

        if (this.evidenceFormEdit) {
          this.isDisplay = true
          this.createForm(this.evidenceFormEdit)
          this.submitEvirefernce()
        }

      })


  }

  ngOnDestroy() {
    this.evidenceSubscription.next();
    this.evidenceSubscription.complete();
    this.deleteEvidenceSubscription.next();
    this.deleteEvidenceSubscription.complete();
  }


  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("userRole Check:", this.user)
    if (this.user && this.user.isLearner) {
      this.isLearner = this.user.isLearner

    }
  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue._id
      this.currentLearner = changes.learnerData.currentValue
    }

    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobId = changes.singleJob.currentValue[0]._id
      this.job = changes.singleJob.currentValue[0]
      console.log("changes in evidence Reference....JOB", changes.singleJob.currentValue);

    }


    // if (this.learnerId && this.jobId) {
    //   this.getEvidenceList()
    // }

    if (changes.evidencerefercnceEdit && changes.evidencerefercnceEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.evidencerefercnceEdit.currentValue)
      this.evidenceFormEdit = changes.evidencerefercnceEdit.currentValue
      console.log("assement plan edit data", this.evidenceFormEdit);

      if (this.evidenceFormEdit && this.evidenceFormEdit.eviReferencePTForm) {
        this.createForm(this.evidenceFormEdit)
      } else {
        this.createForm()
      }

    }

    if (changes.evidenceList && changes.evidenceList.currentValue) {
      this.evidenceList = changes.evidenceList.currentValue
    }

  }


  //create Form 

  createForm(details?) {
    this.eviReferencePTForm = new FormGroup({
      eviref1: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref1 : ''),
      eviref2: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref2 : ''),
      eviref3: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref3 : ''),
      eviref4: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref4 : ''),
      eviref5: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref5 : ''),
      eviref6: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref6 : ''),
      eviref7: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref7 : ''),
      eviref8: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref8 : ''),
      eviref9: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref9 : ''),
      eviref10: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref10 : ''),
      eviref11: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref11 : ''),
      eviref12: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref12 : ''),
      eviref13: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref13 : ''),
      eviref14: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref14 : ''),
      eviref15: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref15 : ''),
      eviref16: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref16 : ''),
      eviref17: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref17 : ''),
      eviref18: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref18 : ''),
      eviref19: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref19 : ''),
      eviref20: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref20 : ''),
      eviref21: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref21 : ''),
      eviref22: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref22 : ''),
      eviref23: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref23 : ''),
      eviref24: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref24 : ''),
      eviref25: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref25 : ''),
      eviref26: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref26 : ''),
      eviref27: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref27 : ''),
      eviref28: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref28 : ''),
      eviref29: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref29 : ''),
      eviref30: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref30 : ''),
      eviref31: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref31 : ''),
      eviref32: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref32 : ''),
      eviref33: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref33 : ''),
      eviref34: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref34 : ''),
      eviref35: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref35 : ''),
      eviref36: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref36 : ''),
      eviref37: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref37 : ''),
      eviref38: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref38 : ''),
      eviref39: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref39 : ''),
      eviref40: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref40 : ''),
      eviref41: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref41 : ''),
      eviref42: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref42 : ''),
      eviref43: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref43 : ''),
      eviref44: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref44 : ''),
      eviref45: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref45 : ''),
      eviref46: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref46 : ''),
      eviref47: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref47 : ''),
      eviref48: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref48 : ''),
      eviref49: new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref49 : ''),
      // eviref50:new FormControl((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref50 : '')

      feedback1: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref1 : '')),
      feedback2: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref2 : '')),
      feedback3: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref3 : '')),
      feedback4: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref4 : '')),
      feedback5: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref5 : '')),
      feedback6: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref6 : '')),
      feedback7: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref7 : '')),
      feedback8: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref8 : '')),
      feedback9: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref9 : '')),
      feedback10: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref10 : '')),
      feedback11: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref11 : '')),
      feedback12: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref12 : '')),
      feedback13: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref13 : '')),
      feedback14: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref14 : '')),
      feedback15: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref15 : '')),
      feedback16: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref16 : '')),
      feedback17: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref17 : '')),
      feedback18: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref18 : '')),
      feedback19: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref19 : '')),
      feedback20: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref20 : '')),
      feedback21: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref21 : '')),
      feedback22: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref22 : '')),
      feedback23: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref23 : '')),
      feedback24: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref24 : '')),
      feedback25: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref25 : '')),
      feedback26: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref26 : '')),
      feedback27: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref27 : '')),
      feedback28: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref28 : '')),
      feedback29: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref29 : '')),
      feedback30: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref30 : '')),
      feedback31: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref31 : '')),
      feedback32: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref32 : '')),
      feedback33: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref33 : '')),
      feedback34: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref34 : '')),
      feedback35: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref35 : '')),
      feedback36: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref36 : '')),
      feedback37: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref37 : '')),
      feedback38: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref38 : '')),
      feedback39: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref39 : '')),
      feedback40: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref40 : '')),
      feedback41: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref41 : '')),
      feedback42: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref42 : '')),
      feedback43: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref43 : '')),
      feedback44: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref44 : '')),
      feedback45: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref45 : '')),
      feedback46: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref46 : '')),
      feedback47: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref47 : '')),
      feedback48: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref48 : '')),
      feedback49: new FormControl(this.displayFeedback((details && details.eviReferencePTForm) ? details.eviReferencePTForm.eviref49 : '')),



    })



  }





  //utility FUNCTION

  compareObjects(o1: any, o2: any): boolean {
    console.log("compareObjects called", o1._id, o2._id)
    return o1._id === o2;
  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }





  displayFeedback(data?) {
    console.log("evidence ARRAY==>", data)
    if (data && data.length) {

      let tempEvidence = this.evidenceList
      let result = tempEvidence.filter(o1 => data.some(o2 => o1._id === o2));
      console.log("Hello Here is the feedback==>", result)

      let tempfeed = []
      let arrayLength = result.length;
      for (let i = 0; i < arrayLength; i++) {

        if (result[i] && result[i].feedback) {
          tempfeed.push(result[i].feedback)
        }
      }

      tempfeed.join()
      return tempfeed

    }

  }

  selectedEvidenceFeed(event, controlName) {

    console.log("Selected changes..", event.value)

    let tempfeed = []
    let data = event.value
    let tempEvidence = this.evidenceList
    let result = tempEvidence.filter(o1 => data.some(o2 => o1._id === o2));
    let arrayLength = result.length;

    for (let i = 0; i < arrayLength; i++) {

      if (result[i] && result[i].feedback) {
        tempfeed.push(result[i].feedback)

      }
    }

    tempfeed.join()
    this.eviReferencePTForm.get(controlName).setValue(tempfeed)
    this.evidenceFormEdit.eviReferencePTForm = this.eviReferencePTForm.value

  }

  //API CALL

  // getEvidenceList(){
  //   console.log("evidence Refernce Here ...CAll");

  //   this._learnerService.getEvidenceByLearner(this.learnerId, this.jobId).subscribe(res => {
  //     console.log("evidence Refernce Here ...", res);
  //     if (res && res.length) {

  //       let tempEvi = []
  //       var arrayLength = res.length;
  //       for (var i = 0; i < arrayLength; i++) {
  //         // console.log(res[i]);
  //         let data = {
  //           _id: (res[i]._id) ? res[i]._id : '',
  //           title: (res[i].title) ? res[i].title : '',
  //           evidenceNo: (res[i].evidenceNo) ? res[i].evidenceNo : '',
  //           feedback: (res[i].feedback) ? res[i].feedback : ''

  //         }
  //         tempEvi.push(data)
  //       }

  //       this.evidenceList = tempEvi
  //       this.createForm(this.evidenceFormEdit)

  //     }
  //   }, (error) => {
  //     console.log("Soeme error occure when Get EVi List", error)
  //   })
  // }



  submitEvirefernce() {
    // this.evireference
    console.log("HELLO EVidence REFFFFF...", this.eviReferencePTForm.value)
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId,
      details: {
        eviReferencePTForm: this.eviReferencePTForm.value
      }
    }

    console.log("EDit Evidence Object Replace", this.evidenceFormEdit.eviReferencePTForm)
    // this.evidenceFormEdit['details'].eviReferencePTForm=this.eviReferencePTForm.value
    this.loading = true
    console.log("eviiiii==>", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.evidenceFormEdit.eviReferencePTForm = this.eviReferencePTForm.value
      if (!this.isDisplay) this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
      this.isDisplay = false
    }, (err) => {
      this.loading = false
      console.log("form not accepted", err)
    })
  }


  downloadEviRef() {
    // let data = this.eviReferencePTForm.value
    let data = {
      learner: this.currentLearner,
      jobId: this.jobId,
      formName: 'eviReferencePTForm'
    }

    this.loading = true
    this._learnerService.evidenceRefPdf(data).subscribe((res) => {
      this.loading = false
      console.log("HELLO HERE IS RESPONSE:::", res.data)
      let byteArray = new Uint8Array(res.data);
      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let title = this.job.title + '-' + this.currentLearner.name.split(' ').join('_') + ' - Criteria' + '.pdf'
      saveAs(blob, title);
      //  this.isSpinner = false
    }, (error) => {
      console.log("pdf Genarate Some error", error)
      this.loading = false

    })

  }

}
